import './sentry.config.ts';
import i18n from '@i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { LoaderProvider } from './contexts/LoaderContext';
import { captureCheckoutIntent } from './libs/checkoutParams';

captureCheckoutIntent(new URLSearchParams(window.location.search));

i18n.on('initialized', () => {
  document.documentElement.lang = i18n.language || 'en';
  // Now render your app
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element not found');
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <LoaderProvider>
        <App />
      </LoaderProvider>
    </React.StrictMode>,
  );
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
